// Commercial-confidentiality wall (§3) — client mirror of the api's _redact_commercial.
// These FIELD names must never reach an export or any serialized client payload:
// purchase price / cost / margin / profit and campaign TERMS/length. NOT a competitor's
// campaign EXISTENCE or shelf prices, which are allowed market data. Matched on key name.
export const COMMERCIAL_KEY =
  /purchase|inköp|inkop|wholesale|procure|cost|kostnad|margin|marginal|profit|vinst|kampanjvillkor|kampanjlängd|kampanjtid|campaign_term|campaign_durat|campaign_length|campaign_cond|avtalsvillkor|\bterms\b|\bvillkor\b/i

export function isCommercialKey(key: string): boolean {
  return COMMERCIAL_KEY.test(key)
}

// Recursively drop any dict key whose NAME matches the wall. Values are never inspected
// (only keys), so legitimate free text that mentions "kampanj" is untouched — only
// structured cost/terms FIELDS are removed. Defense-in-depth before serialization.
export function redactCommercial<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map((x) => redactCommercial(x)) as unknown as T
  }
  if (obj && typeof obj === 'object') {
    const out: Record<string, unknown> = {}
    for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
      if (!isCommercialKey(k)) out[k] = redactCommercial(v)
    }
    return out as T
  }
  return obj
}
